import { LEARNING_SUBJECT_STORAGE_KEY } from "../constants/storageKeys";

export const getStoredLearningSubject = () => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return localStorage.getItem(LEARNING_SUBJECT_STORAGE_KEY);
  } catch (error) {
    console.error("Failed to read stored learning subject:", error);
    return null;
  }
};

export const persistLearningSubjectSelection = (subject) => {
  if (typeof window === "undefined" || !subject) {
    return;
  }
  try {
    localStorage.setItem(LEARNING_SUBJECT_STORAGE_KEY, subject);
  } catch (error) {
    console.error("Failed to persist learning subject:", error);
  }
};

export const clearStoredLearningSubject = () => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.removeItem(LEARNING_SUBJECT_STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear learning subject:", error);
  }
};
